import { ERROR_COPY, ERROR_FALLBACK } from '@/constants/errors';

const resolveErrorCopy = (code?: string | null): string | undefined => {
  if (!code) {
    return undefined;
  }

  return ERROR_COPY[code] ?? ERROR_FALLBACK;
};

export {
  resolveErrorCopy,
};
